var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.6349 0.587524H0.300293V74.9221H74.6349V0.587524Z",
    fill: "#3E5C9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8047 60.2212H40.8521V37.5644H47.1645L47.8371 29.9783H40.8521C40.8521 29.9783 40.8521 27.1459 40.8521 25.6577C40.8521 23.869 41.2117 23.1622 42.9404 23.1622C44.3322 23.1622 47.8371 23.1622 47.8371 23.1622V15.29C47.8371 15.29 42.675 15.29 41.5724 15.29C34.8402 15.29 31.8047 18.255 31.8047 23.9301C31.8047 28.8735 31.8047 29.9783 31.8047 29.9783H27.0986V37.6587H31.8047V60.2212Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1ff2232b50aed75e26ec87f895200268.svg";
export { ForwardRef as ReactComponent };